// extracted by mini-css-extract-plugin
export default {"content-error":"EditProfile_content-error__eE4Vu","content-loading":"EditProfile_content-loading__vQ6+t"};